import React, {useEffect, useState} from "react";
import css from './RequestHelpForm.css';
import PropTypes from "prop-types";
import RequestHelpInterventionSelect from "./RequestHelpInterventionSelect";
import RequestHelpCourseSelect from "./RequestHelpCourseSelect";
import RequestHelpDetailsTextArea from "./RequestHelpDetailsTextArea";
import useStarfishAPI from "../hooks/useStarfishAPI";
import {urlParams} from "../utils/request";
import ConfirmDialog from "../common/ConfirmDialog";
import sanitize from "sanitize-html";

const RequestHelpForm = ({
  studentId,
  setFormInvalid,
  interventionRule,
  course,
  details,
  setInterventionRule,
  setCourse,
  setDetails,
  interventionRuleList,
  setInterventionRuleList
}) => {

  const [interventionRulesResponse, callInterventionRulesAPI] = useStarfishAPI();
  const [showRequestHelpForm, setShowRequestHelpForm] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)

  useEffect(() => {
    callInterventionRulesAPI('../instructor/getManualInterventionRules.html', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: urlParams({
        studentId: studentId
      })
    });
  }, []);

  useEffect(() => {
    if (interventionRulesResponse.success) {
      const rules = interventionRulesResponse.data.rules.map(rule => {
        return {
          id: rule.id,
          name: rule.name,
          description: sanitize(rule.description, {
            allowedTags: [],
            allowedAttributes: {},
          }),
          courseSelectionSetting: rule.courseSelectionSetting,
          commentRequired: rule.commentRequired,
          raiseCommentTemplate: rule.raiseCommentTemplate
        }
      }).sort((rule, nextRule) => {
        if (rule.name > nextRule.name) return 1
        else if (rule.name < nextRule.name) return -1
        else return 0
      });
      setInterventionRuleList(rules);
      setShowRequestHelpForm(rules.length > 0)
    }
  }, [interventionRulesResponse]);

  const changeRule = (rule) => {
    if (interventionRule && rule.id !== interventionRule.id && !!details) {
      setOpenDialog(true);
    } else {
      setDetails(rule.raiseCommentTemplate || '');
    }
    setInterventionRule(rule);
  }

  const confirmCurrentDetails = () => {
    setOpenDialog(false);
  }

  const confirmNewDetails = () => {
    setOpenDialog(false);
    setDetails(interventionRule.raiseCommentTemplate || '')
  }

  const isCourseAllowed = !!interventionRule && interventionRule.courseSelectionSetting !== "DISALLOWED";
  const isCourseRequired = !!interventionRule && interventionRule.courseSelectionSetting === "REQUIRED";
  const isDetailsRequired = !!interventionRule && interventionRule.commentRequired

  useEffect(() => {
    setFormInvalid(!interventionRule || (isCourseRequired && !course) || (isDetailsRequired && !details));
  }, [interventionRule, course, details]);

  return (
      <div>
        {showRequestHelpForm &&
          <div className={css['form']}>
            <RequestHelpInterventionSelect setInterventionRule={changeRule}
                                           interventionRule={interventionRule}
                                           interventionRules={interventionRuleList}/>
            <RequestHelpCourseSelect setCourse={setCourse}
                                     course={course}
                                     isCourseRequired={isCourseRequired}
                                     interventionRule={interventionRule}
                                     studentId={studentId}
                                     isCourseAllowed={isCourseAllowed}/>
            <RequestHelpDetailsTextArea details={details}
                                        isDetailsRequired={isDetailsRequired}
                                        setDetails={setDetails}
              />
          </div>
        }
        <ConfirmDialog
            isOpen={openDialog}
            headerText={"Clear Details"}
            descriptionText={"A new type was selected. Would you like to replace the current details with the selected type template?"}
            confirmText="Yes"
            cancelText="No"
            onClose={confirmCurrentDetails}
            onConfirm={confirmNewDetails}
        />
      </div>
  );

};

RequestHelpForm.propTypes = {
  studentId: PropTypes.number.isRequired,
  setFormInvalid: PropTypes.func.isRequired,
  interventionRule: PropTypes.object,
  course: PropTypes.object,
  details: PropTypes.string,
  setInterventionRule: PropTypes.func.isRequired,
  setCourse: PropTypes.func.isRequired,
  setDetails: PropTypes.func.isRequired,
  interventionRuleList: PropTypes.array.isRequired,
  setInterventionRuleList: PropTypes.func.isRequired
};

export default RequestHelpForm;
